/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MultiDayAttendanceEntryRequest } from './MultiDayAttendanceEntryRequest';
import {
    MultiDayAttendanceEntryRequestFromJSON,
    MultiDayAttendanceEntryRequestFromJSONTyped,
    MultiDayAttendanceEntryRequestToJSON,
    MultiDayAttendanceEntryRequestToJSONTyped,
} from './MultiDayAttendanceEntryRequest';

/**
 * 
 * @export
 * @interface MultiDayAttendanceRequest
 */
export interface MultiDayAttendanceRequest {
    /**
     * 
     * @type {Date}
     * @memberof MultiDayAttendanceRequest
     */
    dateFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof MultiDayAttendanceRequest
     */
    dateTo: Date;
    /**
     * 
     * @type {string}
     * @memberof MultiDayAttendanceRequest
     */
    originTimeZoneId: string;
    /**
     * 
     * @type {MultiDayAttendanceEntryRequest}
     * @memberof MultiDayAttendanceRequest
     */
    entry: MultiDayAttendanceEntryRequest;
}

/**
 * Check if a given object implements the MultiDayAttendanceRequest interface.
 */
export function instanceOfMultiDayAttendanceRequest(value: object): value is MultiDayAttendanceRequest {
    if (!('dateFrom' in value) || value['dateFrom'] === undefined) return false;
    if (!('dateTo' in value) || value['dateTo'] === undefined) return false;
    if (!('originTimeZoneId' in value) || value['originTimeZoneId'] === undefined) return false;
    if (!('entry' in value) || value['entry'] === undefined) return false;
    return true;
}

export function MultiDayAttendanceRequestFromJSON(json: any): MultiDayAttendanceRequest {
    return MultiDayAttendanceRequestFromJSONTyped(json, false);
}

export function MultiDayAttendanceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultiDayAttendanceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dateFrom': (new Date(json['dateFrom'])),
        'dateTo': (new Date(json['dateTo'])),
        'originTimeZoneId': json['originTimeZoneId'],
        'entry': MultiDayAttendanceEntryRequestFromJSON(json['entry']),
    };
}

export function MultiDayAttendanceRequestToJSON(json: any): MultiDayAttendanceRequest {
    return MultiDayAttendanceRequestToJSONTyped(json, false);
}

export function MultiDayAttendanceRequestToJSONTyped(value?: MultiDayAttendanceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dateFrom': `${value['dateFrom'].getFullYear()}-${String(value['dateFrom'].getMonth()+1).padStart(2,'0')}-${String(value['dateFrom'].getDate()).padStart(2,'0')}`,
        'dateTo': `${value['dateTo'].getFullYear()}-${String(value['dateTo'].getMonth()+1).padStart(2,'0')}-${String(value['dateTo'].getDate()).padStart(2,'0')}`,
        'originTimeZoneId': value['originTimeZoneId'],
        'entry': MultiDayAttendanceEntryRequestToJSON(value['entry']),
    };
}

